'use client';

import { useMemo } from 'react';
import NationalCodeFrom from '../components/national-code-form';
import { useAuthStore } from '../store';
import MobileFrom from '../components/mobile-form';
import { useLoginDisplay } from '@/api/hooks/auth/useLoginDisplay';
export const LoginContainerFactory = () => {
  const {
    data,
    isPending
  } = useLoginDisplay();
  const {
    setHasSejam
  } = useAuthStore();
  const isLoadFromMobileContainer = useMemo(() => {
    return data?.type === 'mobile';
  }, [data?.type]);
  if (isPending) {
    return null;
  }
  const Result = () => {
    if (isLoadFromMobileContainer) {
      return <MobileFrom />;
    }
    return <NationalCodeFrom setHasSejam={setHasSejam} data-sentry-element="NationalCodeFrom" data-sentry-component="Result" data-sentry-source-file="LoginContainerFactory.tsx" />;
  };
  return <Result data-sentry-element="Result" data-sentry-component="LoginContainerFactory" data-sentry-source-file="LoginContainerFactory.tsx" />;
};